import { AppendReason, RemoveReason, ViewUpdate, VList, VObjectInList, VObjectInListWithParent } from "@1oo4/miv";
import { MCell, MCellContent, MCellPicture, MCellText, MRow } from "../../shared/model/mdoc";
import { VTable } from "./contents";
import { VRichTextItem } from "./richtexts";
import { MRichTextItem } from "../../shared/model/richtext";
import { PictureManager } from "../../shared/uitools/picturetools";

export class VRow extends VObjectInList<MRow, VTable> {

    readonly view: HTMLTableRowElement;
    readonly cells: VList<VCell, MCell>;

    constructor(m: MRow, parent: VTable) {
        super(m, parent);
        this.view = document.createElement("tr");
        this.cells = new VList(m.Cells, this, x => new VCell(x, this));
    }

    protected AppendToGUI(ar: AppendReason, vu: ViewUpdate): void {
        this.Parent.view.appendChild(this.view);
    }
    protected InsertIntoGUI(index: number, vu: ViewUpdate): void {
        this.Parent.view.insertBefore(this.view, this.Parent.view.children[index]);
    }
    protected RemoveFromGUI(rr: RemoveReason, vu: ViewUpdate): void {
        this.Parent.view.removeChild(this.view);
    }
}

export class VCell extends VObjectInList<MCell, VRow> {

    readonly view: HTMLTableCellElement;
    private readonly contents: VList<VCellContent, MCellContent>;

    constructor(m: MCell, row: VRow) {
        super(m, row);
        this.view = document.createElement("td");
        this.contents = new VList(m.Content, this, x => x.makeViewDoc(this));
    }

    protected AppendToGUI(ar: AppendReason, vu: ViewUpdate): void {
        this.Parent.view.appendChild(this.view);
    }
    protected InsertIntoGUI(index: number, vu: ViewUpdate): void {
        this.Parent.view.insertBefore(this.view, this.Parent.view.children[index]);
    }
    protected RemoveFromGUI(rr: RemoveReason, vu: ViewUpdate): void {
        this.Parent.view.removeChild(this.view);
    }
}

export abstract class VCellContent extends VObjectInListWithParent<VCell> {

    constructor(m: MCellContent, cell: VCell) {
        super(m, cell);
    }
    abstract getView(): HTMLElement;
    protected AppendToGUI(ar: AppendReason, vu: ViewUpdate): void {
        this.Parent.view.appendChild(this.getView());
    }
    protected InsertIntoGUI(index: number, vu: ViewUpdate): void {
        this.Parent.view.insertBefore(this.getView(), this.Parent.view.children[index]);
    }
    protected RemoveFromGUI(rr: RemoveReason, vu: ViewUpdate): void {
        this.Parent.view.removeChild(this.getView());
    }
}

export class VCellText extends VCellContent {
    private readonly mText: MCellText
    private readonly paragraph: HTMLParagraphElement;
    private readonly richText: VList<VRichTextItem, MRichTextItem>;

    constructor(m: MCellText, parent: VCell) {
        super(m, parent);
        this.mText = m;
        this.paragraph = document.createElement("p");
        this.richText = new VList(m.RichText, this, x => x.makeView(this.paragraph, parent.Parent.Parent));
    }
    getView(): HTMLElement {
        return this.paragraph;
    }
}

export class VCellPicture extends VCellContent {
    private readonly mPicture: MCellPicture;
    private readonly image: PictureManager;

    constructor(m: MCellPicture, parent: VCell) {
        super(m, parent);
        this.mPicture = m;
        this.image = new PictureManager;
    }
    getView(): HTMLElement {
        return this.image.image;
    }

    protected ModelUpdated(vu: ViewUpdate): void {
        if (vu.IsChanged(this.mPicture.Data)) {
            this.image.setPicture(this.mPicture.Data);
        }
    }
}